module.exports = __webpack_public_path__ + "img/arm-header-icons-hover-05.ec6f2568.svg";